import cx from 'classnames';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import fetcher from '@/forApp/utils/fetcher/fetcher';
import type { ItemSelectT } from '@/shared/Selects/Select';
import DinamycSearch from '@/widgets/MainBlock/MainSearch/FormSearch/DinamycSearch/DinamycSearch';
import { SelectEntityType } from '@/widgets/MainBlock/MainSearch/FormSearch/SelectEntityType/SelectEntityType';
import type {
  AllowFiltersT,
  DefaultFilterT,
  MoreFiltersT,
} from '@/widgets/MainBlock/MainSearch/types';
import styles from './styles.module.css';

export type MainPageFiltersT = {
  moreFilter: MoreFiltersT;
  allowFilters: AllowFiltersT;
  typeEntity: Record<string, ItemSelectT[]>;
};
type FormSearchT = {
  defaultFilter: DefaultFilterT;
  isMobile?: boolean;
};

const FormSearch: React.FC<FormSearchT> = ({ defaultFilter, isMobile }) => {
  const { filters } = useApp();
  const [dataForFilters, setDataForFilters] =
    useState<DefaultFilterT>(defaultFilter);

  useEffect(() => {
    fetcher<AllowFiltersT>(
      'GET',
      `/entity-types/allow-filters/${filters.type === 'commercial' ? 'storages' : filters.type}`,
    ).then((res) => {
      setDataForFilters({
        ...dataForFilters,
        allowFilters: {
          cities: [{ name: 'Все города', slug: '' }, ...res.data.cities].map(
            (item): ItemSelectT => ({
              value: item.slug ? item.slug : '',
              title: item.name,
            }),
          ),
          filters: res.data.filters,
        },
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.type]);
  return (
    <div className={cx(isMobile ? styles.formSearchMobile : styles.formSearch)}>
      <SelectEntityType isMobile={isMobile} />
      <DinamycSearch dataForFilters={dataForFilters} isMobile={isMobile} />
    </div>
  );
};

export default FormSearch;
